// Where owner and owner-message alerts open, for the bell and phone alerts.
// A byte identical copy lives in supabase/functions/_shared/notificationRoutes.ts
// (a test keeps them equal). Returns null for types this file does not own.

export const OWNER_ALERT_TYPES = [
  "owner_message",
  "owner_content_removed",
  "owner_edit_approved",
  "owner_edit_rejected",
  "admin_owner_message",
] as const;

export function ownerAlertPath(type: string, data: Record<string, unknown> | null | undefined): string | null {
  const d = data ?? {};
  const str = (v: unknown) => (typeof v === "string" && v ? v : null);
  switch (type) {
    case "owner_message":
      return "/owner/messages";
    case "owner_content_removed":
      return "/owner/media";
    case "owner_edit_approved":
    case "owner_edit_rejected": {
      const field = str(d.field_name);
      return field ? `/owner/listing?field=${encodeURIComponent(field)}` : "/owner/listing";
    }
    case "admin_owner_message": {
      const cafe = str(d.cafe_id);
      return cafe ? `/admin?tab=messages&cafe=${encodeURIComponent(cafe)}` : "/admin?tab=messages";
    }
    default:
      return null;
  }
}

/** Only paths inside the app: one leading slash, never "//" or "/\". */
export function safeInternalPath(p: string | null | undefined, fallback: string): string {
  if (typeof p !== "string" || !p.startsWith("/") || p.startsWith("//") || p.startsWith("/\\")) return fallback;
  return p;
}
